// Sticky, glass header with brand, theme toggle and language switcher.

import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { RAFFLE_NS } from './translations';
import Logo from './Logo';
import LanguageSwitcher from './LanguageSwitcher';
import ThemeToggle from './ThemeToggle';

const Header = ({ theme, onToggleTheme }) => {
  const { t } = useTranslation(RAFFLE_NS);

  return (
    <motion.header
      className="rf-header rf-grain"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="rf-header__inner">
        <a className="rf-brand" href="#rf-top" aria-label={`${t('header.brand')} — ${t('header.tagline')}`}>
          <Logo className="rf-brand__logo" />
          <span className="rf-brand__tag">{t('header.tagline')}</span>
        </a>

        <div className="rf-header__actions">
          <ThemeToggle theme={theme} onToggle={onToggleTheme} />
          <LanguageSwitcher />
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
